import {pickAll} from 'ramda'
import {ProviderRequestType} from 'types/providerInfo'

import {UrlCheckoutParamsType} from '@vio/core/src/utils/url/types/UrlParams'

const getDefaultParams = (params: UrlCheckoutParamsType) =>
  pickAll<UrlCheckoutParamsType, ProviderRequestType>(['countryCode'], params)

export default getDefaultParams
